import React from 'react';
import { Button } from 'semantic-ui-react';
import cn from 'classnames';
import ModalBase, { BaseModalProps } from '../../ModalBase/ModalBase';
import { useTranslation } from 'react-i18next';

interface AlertProps {
  type?: 'success' | 'error' | string;
  actionText?: string;
  message: string;
  baseModalProps: BaseModalProps;
  onSuccess: (args: { close: () => void }) => void;
  hideBackButton?: boolean;
  onBack?: () => void;
  backImg?: string;
  close: () => void;
}

const Alert: React.FC<AlertProps> = ({
  type,
  actionText,
  message,
  baseModalProps,
  onSuccess,
  hideBackButton,
  onBack,
  backImg = 'Back',
  close
}) => {
  const { t } = useTranslation(['common']);

  return (
    <ModalBase
      baseModalProps={baseModalProps}
      back_img={backImg}
      contentClassName="confirmation"
      className={cn({ success: type === 'success', error: type === 'error' })}
      hideBackButton={hideBackButton}
      onBack={onBack}
    >
      <div className="confirmationMessage">
        <p>{message}</p>
      </div>

      <div className="actions">
        <Button
          primary
          onClick={() => {
            onSuccess({
              close
            });
          }}
          data-cy="action-btn"
        >
          {actionText || t('common:buttons.ok')}
        </Button>
      </div>
    </ModalBase>
  );
};



export default Alert;
